import React from 'react';
import { Typography } from '@mui/material';
import BenchDataFields from '../../../../../../../common/BenchDataFields';

/**
 * Bench details step for the transfer/attach wizard.
 * Allows setting bench type, star flag, comments, bench manager and salary
 * when attaching to or transferring to a bench project.
 *
 * Uses the shared BenchDataFields component for all form controls.
 *
 * @param {Object} props
 * @param {string} props.benchType
 * @param {Function} props.setBenchType
 * @param {boolean} props.flagAsStar
 * @param {Function} props.setFlagAsStar
 * @param {string} props.comments
 * @param {Function} props.setComments
 * @param {Object|null} props.benchManager - Currently selected bench manager employee object
 * @param {Function} props.setBenchManager
 * @param {Object|null} props.directManager - The employee's current org manager (read-only context)
 * @param {string} props.salary
 * @param {Function} props.setSalary
 * @param {string} props.salaryCurrency
 * @param {Function} props.setSalaryCurrency
 * @param {string} props.salaryPeriod
 * @param {Function} props.setSalaryPeriod
 * @param {string} props.salaryAmountType
 * @param {Function} props.setSalaryAmountType
 */
const BenchDetailsStep = ({
  benchType,
  setBenchType,
  flagAsStar,
  setFlagAsStar,
  comments,
  setComments,
  benchManager,
  setBenchManager,
  directManager,
  salary,
  setSalary,
  salaryCurrency,
  setSalaryCurrency,
  salaryPeriod,
  setSalaryPeriod,
  salaryAmountType,
  setSalaryAmountType,
}) => {
  return (
    <>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Configure bench-specific details for this assignment.
      </Typography>

      <BenchDataFields
        benchType={benchType}
        setBenchType={setBenchType}
        flagAsStar={flagAsStar}
        setFlagAsStar={setFlagAsStar}
        comments={comments}
        setComments={setComments}
        benchManager={benchManager}
        setBenchManager={setBenchManager}
        directManager={directManager}
        salary={salary}
        setSalary={setSalary}
        salaryCurrency={salaryCurrency}
        setSalaryCurrency={setSalaryCurrency}
        salaryPeriod={salaryPeriod}
        setSalaryPeriod={setSalaryPeriod}
        salaryAmountType={salaryAmountType}
        setSalaryAmountType={setSalaryAmountType}
        instanceId="bench-details-bench-manager"
      />
    </>
  );
};

export default BenchDetailsStep;
